import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type PortalResponse = components["schemas"]["PortalResponse"];

/**
 * POST /v1/billing/portal — open the Polar customer portal; returns its URL.
 * The backend answers 400 when there is no active subscription.
 */
export async function createPortal(): Promise<PortalResponse> {
  return unwrap(await api.POST("/v1/billing/portal"));
}
